// Metrics are entered manually until an analytics catalogue is connected.
export const METRIC_SOURCES = ['Manual'];
export const METRICS = [];

export const findMetric = (name) => METRICS.find((m) => m.name.toLowerCase() === String(name || '').trim().toLowerCase());

/** Manual metrics use only the saved planning inputs. */
export const manualMetric = (name, fallback = {}) => ({
    name, source: 'Manual', definition: 'entered by hand', scope: 'This test',
    baseline: fallback.baseline ?? null, dailyTraffic: fallback.dailyTraffic ?? null, display: fallback.baseline == null ? '—' : `${(fallback.baseline * 100).toFixed(1)}%`, verified: false,
});

/** Case-insensitive match on name, definition, source or scope; best matches first. */
export const searchMetrics = (query) => {
    const text = String(query || '').trim().toLowerCase();
    if (!text) return METRICS;
    return METRICS
        .map((m) => {
            const name = m.name.toLowerCase();
            const score = name.startsWith(text) ? 0
                : name.includes(text) ? 1
                    : [m.definition, m.source, m.scope].some((v) => v.toLowerCase().includes(text)) ? 2 : -1;
            return { m, score };
        })
        .filter(({ score }) => score >= 0)
        .sort((a, b) => a.score - b.score)
        .map(({ m }) => m);
};
